import { Box, Typography } from "@mui/material";
import { type FC, useCallback, useState } from "react";
import { useIsDemoDraftWeek } from "@/hooks/useDemoDraftWeeks";
import { useDepartmentFlags } from "@/hooks/useDepartmentFlags";
import { INK } from "@/theme/tokens";
import SystemDialog from "@/ui/Popups/Dialog";
import SystemButton from "@/ui/SystemButton/SystemButton";

type Props = {
	onPublish?: () => void;
	weekIndex: number;
};

export const DraftMode: FC<Props> = ({ onPublish, weekIndex }) => {
	const { isHospitalDemo } = useDepartmentFlags();
	const [warningDisplayed, setWarningDisplayed] = useState(false);
	const toggleWarning = useCallback(() => {
		setWarningDisplayed((prevState) => !prevState);
	}, []);
	const handlePublish = useCallback(() => {
		onPublish?.();
		toggleWarning();
	}, [onPublish, toggleWarning]);
	const isDraftMode = useIsDemoDraftWeek(weekIndex) && isHospitalDemo;

	return isDraftMode ? (
		<Box
			data-testid="staffing-draft-mode-toggle"
			sx={{
				display: "flex",
				marginInline: 1,
				alignItems: "center",
				justifyContent: "center",
				gap: 1,
			}}
		>
			{warningDisplayed && (
				<SystemDialog
					open={warningDisplayed}
					onClose={toggleWarning}
					title={"Publish schedule"}
					body={"Are you sure you want to publish this schedule?"}
					onConfirm={handlePublish}
				/>
			)}
			<Typography
				variant={"h4"}
				sx={{
					color: INK.SECONDARY,
				}}
			>
				Draft Mode
			</Typography>
			<SystemButton data-testid="staffing-publish-button" onClick={toggleWarning}>
				Publish
			</SystemButton>
		</Box>
	) : null;
};
